if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        const layout = this.querySelector('.product-media-modal__layout');
        if (layout) {
          layout.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        this.setupThumbnails();
        this.setupNavigation();
        this.setupSwipe();
        this.setupKeyboard();
        this.setupActiveImageClose();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.syncThumbnails(mediaId);
        this.updateCounter();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      switchToMedia(mediaId) {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        content.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));
        const target = content.querySelector(`[data-media-id="${mediaId}"]`);
        if (!target) return;

        target.classList.add('active');
        this.syncThumbnails(mediaId);
        this.updateCounter();

        const template = target.querySelector('template');
        if (
          target.nodeName === 'DEFERRED-MEDIA' &&
          template &&
          template.content.querySelector('.js-youtube')
        ) {
          target.loadContent();
        }
      }

      getMediaItems() {
        const content = this.querySelector('.product-media-modal__content');
        return content ? [...content.querySelectorAll('[data-media-id]')] : [];
      }

      navigatePrev() {
        const items = this.getMediaItems();
        const idx = items.findIndex((el) => el.classList.contains('active'));
        if (idx === -1 || items.length < 2) return;
        const newIdx = idx > 0 ? idx - 1 : items.length - 1;
        this.switchToMedia(items[newIdx].dataset.mediaId);
      }

      navigateNext() {
        const items = this.getMediaItems();
        const idx = items.findIndex((el) => el.classList.contains('active'));
        if (idx === -1 || items.length < 2) return;
        const newIdx = idx < items.length - 1 ? idx + 1 : 0;
        this.switchToMedia(items[newIdx].dataset.mediaId);
      }

      syncThumbnails(activeMediaId) {
        const id = String(activeMediaId);
        this.querySelectorAll('.product-media-modal__thumb').forEach((thumb) => {
          const isActive = thumb.dataset.thumbMediaId === id;
          thumb.classList.toggle('active', isActive);
          if (isActive) thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }

      updateCounter() {
        const counter = this.querySelector('.product-media-modal__counter');
        if (!counter) return;
        const items = this.getMediaItems();
        const idx = items.findIndex((el) => el.classList.contains('active'));
        if (idx === -1) return;
        counter.textContent = `${idx + 1} / ${items.length}`;
      }

      setupThumbnails() {
        this.addEventListener('click', (e) => {
          const thumb = e.target.closest('.product-media-modal__thumb');
          if (thumb && thumb.dataset.thumbMediaId) {
            this.switchToMedia(thumb.dataset.thumbMediaId);
          }
        });
      }

      setupNavigation() {
        this.addEventListener('click', (e) => {
          const nav = e.target.closest('.product-media-modal__nav');
          if (!nav) return;
          if (nav.classList.contains('product-media-modal__nav--prev')) {
            this.navigatePrev();
          } else {
            this.navigateNext();
          }
        });
      }

      setupSwipe() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        let startX = 0;
        let startY = 0;

        content.addEventListener(
          'touchstart',
          (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          },
          { passive: true }
        );

        content.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
              if (dx > 0) this.navigatePrev();
              else this.navigateNext();
            }
          },
          { passive: true }
        );
      }

      setupKeyboard() {
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigatePrev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateNext();
          }
        });
      }

      setupActiveImageClose() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        content.addEventListener('click', (e) => {
          const activeMedia = e.target.closest('[data-media-id].active');
          if (activeMedia) this.hide();
        });
      }
    }
  );
}
